// "Změnit heslo": the logged-in user changes their own password (current one required).
// Other sessions of the account end; this one continues with the fresh token.
import React, { useState } from 'react';
import api, { getErrorMessage } from '../services/api';
import authService from '../services/authService';
import { Alert, Button, Modal, useToast } from './ui';
import PasswordField from './leader/PasswordField';

const MIN_PASSWORD = 8;

export default function ChangePasswordDialog({ onClose }) {
  const toast = useToast();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [again, setAgain] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next.length < MIN_PASSWORD) {
      setError(`Nové heslo musí mít alespoň ${MIN_PASSWORD} znaků.`);
      return;
    }
    if (next !== again) {
      setError('Nová hesla se neshodují.');
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.post('/auth/change-password', { currentPassword: current, newPassword: next });
      if (data?.token) authService.setAuthData({ token: data.token, user: data.user });
      toast.success('Heslo bylo změněno. Na ostatních zařízeních se přihlaste znovu.');
      onClose();
    } catch (err) {
      setError(getErrorMessage(err, 'Heslo se nepodařilo změnit.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Změnit heslo"
      onClose={saving ? undefined : onClose}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Zrušit
          </Button>
          <Button type="submit" form="change-password-form" loading={saving}>
            Uložit nové heslo
          </Button>
        </>
      }
    >
      <form id="change-password-form" className="space-y-4" onSubmit={submit} noValidate>
        <PasswordField
          id="current-password"
          label="Současné heslo"
          autoComplete="current-password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          required
        />
        <PasswordField
          id="new-password"
          label="Nové heslo"
          autoComplete="new-password"
          value={next}
          onChange={(e) => setNext(e.target.value)}
          hint={`Alespoň ${MIN_PASSWORD} znaků.`}
          required
        />
        <PasswordField
          id="new-password-again"
          label="Nové heslo znovu"
          autoComplete="new-password"
          value={again}
          onChange={(e) => setAgain(e.target.value)}
          error={again && next !== again ? 'Hesla se neshodují.' : null}
          required
        />
        {error && <Alert tone="error">{error}</Alert>}
      </form>
    </Modal>
  );
}
